import React, { useState } from 'react';
import * as ReactDOM from 'react-dom';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router';
import { useIntl } from 'react-intl';
import { Button, Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  APPLICATION_STATUS,
  APPLY_METHOD_TYPE,
  PROCEDURE_CARRIER_TYPES,
  PROCEDURE_SZLT_TYPES, PROCEDURE_TYPE,
  PROCEDURE_VEHICLE_TYPES, USER_TYPE, USER_TYPE_LIST,
} from '../../../configs';
import FormHeader from './FormHeader';
import ApplicationInfo from './FormBlocks/ApplicationInfo';
import ApplicantForm from './FormBlocks/ApplicantForm';
import RepresentativeForm from './FormBlocks/RepresentativeForm';
import {
  carrierHelper,
  szltHelper,
  vehiclesHelper,
} from '../../RegionRegistry/actions';
import ApplicationVehicleForm from './FormBlocks/ApplicationVehicleForm';
import ApplicationCarrierForm from './FormBlocks/ApplicationCarrierForm';
import ApplicationSzltForm from './FormBlocks/ApplicationSzltForm';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import {
  getResponseError, removeNulls, responseLogWithNotification, setFormError,
} from '../../../utils/utils';
import { applicationFieldsValidation, createApplication, editApplicationById } from '../actions';
import UploadZone from '../../../components/fields/FileInput/UploadZone';
import {
  deleteFile, showGlobalConfirm, uploadFile,
} from '../../System/actions';
import UploadFileList from '../../System/components/UploadFileList';
import { getApplicationData } from '../reducer';
import { UNPROCESSABLE_ENTITY } from '../../../configs/serverStatusCodes';
import FieldDTOWithCol from '../../../components/fields/Abstract/FieldDTOWithCol';
import FileView from '../../../components/fields/FileInput/FileView';
import { renderValidationMessage } from '../../../utils/formatters';
import TimerLoader from '../../../components/base/Loader/TimerLoader';
import TextAreaWithLabel from '../../../components/fields/TextInput/TextAreaWithLabel';
import AccordionWithPreview from '../../../components/base/Accordion/AccordionWithPreview';
import ReorganizationJuridicalForm from './FormBlocks/NewValue/ReorganizationJuridicalForm';
import ServiceMarkForm from './FormBlocks/NewValue/ServiceMarkForm';
import AddressForm from './FormBlocks/NewValue/AddressForm';
import OgrnForm from './FormBlocks/NewValue/OgrnForm';
import OgrnipForm from './FormBlocks/NewValue/OgrnipForm';
import DriverLicenseForm from './FormBlocks/NewValue/DriverLicenseForm';
import VehicleRegistryBasisForm from './FormBlocks/NewValue/VehicleRegistryBasisForm';
import VehicleCertificateForm from './FormBlocks/NewValue/VehicleCertificateForm';
import ContractForm from './FormBlocks/NewValue/ContractForm';
import SPBForm from './FormBlocks/NewValue/SPBForm';
import FIOForm from './FormBlocks/NewValue/FIOForm';
import NewSZLTForm from './FormBlocks/NewValue/NewSZLTForm';
import ApplicationCarrierSzltForm from './FormBlocks/ApplicationCarrierSzltForm';
import { getClientCompanyData } from '../../Authorized/reducer';

export default function ApplicationForm(props) {
  const {
    onCancel = () => {},
    onClose = () => {},
    loadData = () => {},
    loadApplication = () => {},
    selectedProcedure = null,
    currentApplication = null,
    isEdit = false,
    fieldsValidation: formMeta,
    title = '',
    titleFull = '',
  } = props;
  const company = useSelector(getClientCompanyData);
  const [toggleRepresentative, setToggleRepresentative] = useState(currentApplication && currentApplication.representative);
  const { formatMessage } = useIntl();
  const { loadingCreateApplication, loadingEditApplicationById, loadingRegisterMaisEgu } = useSelector(getApplicationData);
  const procedure = (!isEdit || !currentApplication) ? selectedProcedure : currentApplication.procedure;
  const dispatch = useDispatch();
  const [legalEntityType, setLegalEntityType] = useState();
  const [additionalFiles, setAdditionalFiles] = useState([]);
  const [loader, setLoader] = useState();
  const [searchParams, setSearchParams] = useSearchParams();
  const [defs, setDefs] = useState(isEdit && currentApplication ? currentApplication : {
    procedure,
    document_submission_type: 1,
    applicant: {
      legal_entity_type: 0,
      isMatch: true,
      applicant_id: '',
      applicant_status: 0,
      ...company,
    }, // isMatch в значение true по умолчанию, если только legal_entity_type по дефолту юрл лицо (0)
    applicant_new: {},
    application_carrier_new: {
      has_employees: true,
    },
    application_vehicle_new: {
      has_special_lifting_device: false,
    },
    application_order_service_new: {},
    additional_file: [],
    apply_method: APPLY_METHOD_TYPE.COMMITTEE,
    application_carrier: {
      vehicles_attach: procedure === PROCEDURE_TYPE.PROCEDURE_1227_1 ? [{ vehicle_number: null }] : [],
      vehicle_detach: [],
      order_services_detach: [],
      order_services_attach: [],
      has_employees: true,
    },
    application_vehicle: {
      has_special_lifting_device: false,
    },
    is_draft: true,
  });

  const [federalLaw, setFederalLaw] = useState((currentApplication?.registry_subjects || [])?.[0]?.federal_law_number);
  const [deletedFileList, setDeletedFileList] = useState([]);

  const {
    watch, reset, setValue, control, getValues, formState: { errors }, setError, getFieldState,
  } = useForm({
    mode: 'onChange',
    defaultValues: defs,
  });

  const handleValidateAndSave = () => {
    if (!currentApplication?.id) {
      return handleSave();
    }
    let values = getValues();

    if (!toggleRepresentative) {
      values = { ...values, representative: null };
    }

    dispatch(applicationFieldsValidation({ id: currentApplication.id, data: { input_data: values, without_media: 1 } })).then(data => {
      const checkErrors = data?.checks || {};
      const errors = data?.errors || {};
      const checkErrorsKeys = Object.keys(checkErrors);
      const errorsKeys = Object.keys(errors);
      if (Object.values(checkErrors).filter(f => f.status !== 2).length + errorsKeys.length) {
        dispatch(showGlobalConfirm({
          confirmTitle: 'Обращение содержит ошибки в полях',
          confirmMessage: renderValidationMessage(errors, checkErrors, checkErrorsKeys, errorsKeys),
          confirmButtonText: 'Сохранить',
          confirmClassName: 'remove-preset',
        })).then(() => {
          handleSave();
        }).catch(() => {
        });
      } else {
        handleSave();
      }
    }).catch(responseLogWithNotification);
  };

  const handleDraft = (isContinue = false) => () => {
    dispatch(showGlobalConfirm({
      confirmMessage: <div className="f2 text-sm-center">{isEdit ? 'Сохранить изменения?' : 'Сохранить черновик?'}</div>,
      confirmButtonText: 'Да',
      confirmCancelButtonText: 'Нет',
      confirmClassName: 'remove-preset',
    })).then(() => {
      handleSave(true, [], !isEdit || currentApplication?.status === APPLICATION_STATUS.DRAFT);
      onClose();
    }).catch(() => {
      if (isContinue) {
        return;
      }
      onClose();
    });
    return false;
  };

  const handleSave = (force = false, addFiles = [], is_draft = false) => {
    const files = [];
    let values = getValues();

    if (!toggleRepresentative && isEdit) {
      values = { ...values, representative: null };
    }

    const fileInputs = [
      { list: values?.media?.criminal_record_certificate_info_doc ? values.media?.criminal_record_certificate_info_doc : null, name: 'criminal_record_certificate_info_doc', required: true },
      { list: values?.media?.driver_license_files ? values.media?.driver_license_files : null, name: 'driver_license_files', required: true },
      // { list: values?.osgop_files ? values.osgop_files : null, name: 'osgop_files' },
      { list: values?.media.apply_files ? values.media.apply_files : null, name: 'apply_files', required: true },
      { list: values?.media?.carriage_file ? values.media.carriage_file : null, name: 'carriage_file' },
      // { list: values?.request_response_files ? values.request_response_files : null, name: 'request_response_files' },
      { list: values?.media?.list_of_documents ? values.media.list_of_documents : null, name: 'list_of_documents' },
      { list: values?.media?.applicant_identity_files ? values.media.applicant_identity_files : null, name: 'applicant_identity_files' },
      { list: values?.media?.representative_identity_files ? values.media.representative_identity_files : null, name: 'representative_identity_files', required: true },
      { list: values?.media?.representative_document_scan ? values.media.representative_document_scan : null, name: 'representative_document_scan', required: true },
      // { list: values?.application_carrier && values.application_carrier.order_services_attach, name: 'order_service_contract_files' }, // обработка ниже
      { list: additionalFiles || null, name: 'additional_file' },
      { list: values?.media.applicant_car_cd_file ? values.media.applicant_car_cd_file : null, name: 'applicant_car_cd_file', required: procedure !== PROCEDURE_TYPE.PROCEDURE_1227_8 },
      { list: values?.media.ownership_contract_files ? values.media.ownership_contract_files : null, name: 'ownership_contract_files', required: procedure !== PROCEDURE_TYPE.PROCEDURE_1227_8 },
      { list: values?.media.car_photo_file ? values.media.car_photo_file : null, name: 'car_photo_file', required: procedure !== PROCEDURE_TYPE.PROCEDURE_1227_8 },
    ];
    for (let i = 0, len = fileInputs.length; i < len; i++) {
      const fileInput = fileInputs[i];
      if (fileInput && fileInput.list) {
        const formFiles = fileInput.list;
        for (let j = 0, len = formFiles.length; j < len; j++) {
          const file = formFiles[j];
          if (file) {
            const data = new FormData();
            data.append('file', file);
            data.append('collection_name', fileInput.name);
            data.append('name', `${file.name}_${j}`);
            files.push(data);
          }
        }
      }
    }

    const order_services_attach = values?.application_carrier?.order_services_attach?.length
      ? values.application_carrier.order_services_attach
      : null;
    const osgop_insurances = values?.osgop_insurances?.length ? values.osgop_insurances : null;
    if (order_services_attach) {
      for (let i = 0, len = order_services_attach.length; i < len; i++) {
        const formFiles = order_services_attach[i].order_service_contract_files || [];
        for (let j = 0, len = formFiles.length; j < len; j++) {
          const file = formFiles[j];
          if (file) {
            const data = new FormData();
            data.append('file', file);
            data.append('collection_name', 'order_service_contract_files');
            data.append('name', `${order_services_attach[i].contract_number || i}_${j}`);
            files.push(data);
          }
        }
        // delete values.application_carrier.order_services_attach[i].order_service_contract_files;
      }
    }
    if (osgop_insurances) {
      for (let i = 0, len = osgop_insurances.length; i < len; i++) {
        const formFiles = osgop_insurances[i].osgop_files || [];
        for (let j = 0, len = formFiles.length; j < len; j++) {
          const file = formFiles[j];
          if (file) {
            const data = new FormData();
            data.append('file', file);
            data.append('collection_name', 'osgop_files');
            data.append('name', `osgop_files_${osgop_insurances[i].insurance_contract_number || i}_${j}`);
            files.push(data);
          }
        }
        // delete values.osgop_insurances[i].osgop_files;
      }
    }

    if (force) {
      values.force_save = true;
    }

    if (is_draft) {
      values.is_draft = true;
    }

    values.applicant_id = values.applicant_id || '';

    removeNulls(values?.applicant_new);
    removeNulls(values?.application_carrier_new);
    removeNulls(values?.application_vehicle_new);
    removeNulls(values?.application_order_service_new);

    const action = isEdit ? editApplicationById({ ...values, id: currentApplication.id }) : createApplication(values);
    // const loadFiles = force && addFiles && addFiles.length ? addFiles : files;
    const loadFiles = files;
    dispatch(action)
      .then(application => {
        const promiseNotification = [];
        successNotification('Сохранение формы обращения', 'Форма сохранена');
        if (deletedFileList && deletedFileList.length) {
          const promises = deletedFileList.map(item => dispatch(deleteFile(item.id)).catch(responseLogWithNotification));
          promiseNotification.push(Promise.all(promises)
            .then(() => {
              successNotification('Удаление файлов обращения', 'Процесс удаления окончен');
            }));
        }
        if (loadFiles && loadFiles.length && application && application.id) {
          setLoader(true);
          const promises = loadFiles.map(formData => {
            formData.append('model_type', 'application');
            formData.append('model_id', application.id);
            return dispatch(uploadFile(formData)).catch(responseLogWithNotification);
          });
          promiseNotification.push(Promise.all(promises)
            .then(() => {
              successNotification('Сохранение файлов обращения', 'Процесс сохранения окончен');
            }));
        }

        if (promiseNotification.length) {
          return Promise.all(promiseNotification).then(() => {
            setLoader(false);
            loadData();
            loadApplication(application.id);
            setSearchParams({ application_id: application.id });
            onCancel();
          })
            .catch(() => {
              setLoader(false);
            });
        }

        onCancel();
        loadData();
        setSearchParams({ application_id: application.id });

        // if (isEdit) {
        //   onCancel();
        // }
      })
      .catch(response => {
        if (response && !force && response.code === UNPROCESSABLE_ENTITY) {
          dispatch(showGlobalConfirm({
            confirmMessage: 'Сохранить без проверок?',
            confirmButtonText: 'Сохранить',
            confirmClassName: 'remove-preset',
          })).then(() => {
            handleSave(true);

            // Требует рефактора после проверки таски TAXI-1294

            if (order_services_attach) {
              for (let i = 0, len = order_services_attach.length; i < len; i++) {
                delete values.application_carrier.order_services_attach[i].order_service_contract_files;
              }
            }

            if (osgop_insurances) {
              for (let i = 0, len = osgop_insurances.length; i < len; i++) {
                delete values.osgop_insurances[i].osgop_files;
              }
            }

            delete values.media.criminal_record_certificate_info_doc;
            delete values.media.driver_license_files;
            delete values.media.apply_files;
            delete values.media.carriage_file;
            delete values.media.applicant_car_cd_file;
            delete values.media.ownership_contract_files;
            delete values.media.car_photo_file;
            // delete values.request_response_files;
            delete values.media.list_of_documents;
            if (values?.media?.applicant_identity_files) {
              delete values.media.applicant_identity_files;
            }
            if (values?.media?.representative_identity_files) {
              delete values.media.representative_identity_files;
            }
            if (values?.media?.representative_document_scan) {
              delete values.media.representative_document_scan;
            }
          }).catch(() => {});
        }
        if (response?.errors) {
          for (let i = 0, len = fileInputs.length; i < len; i++) {
            const fileInput = fileInputs[i];
            if (fileInput.required && !fileInput?.list?.length && typeof values?.media[fileInput.name] !== 'undefined') {
              response.errors[`media.${fileInput.name}`] = [
                `Поле ${formatMessage({ id: fileInput.name })} обязательно.`,
              ];
            }
          }
          if (order_services_attach) {
            for (let i = 0, len = order_services_attach.length; i < len; i++) {
              const formFiles = order_services_attach[i].order_service_contract_files || [];
              if (!formFiles?.length) {
                response.errors[`application_carrier.order_services_attach.${i}.order_service_contract_files`] = [
                  `Поле ${formatMessage({ id: 'media.order_service_contract_files' })} обязательно.`,
                ];
              }
            }
          }
          if (osgop_insurances) {
            for (let i = 0, len = osgop_insurances.length; i < len; i++) {
              const formFiles = osgop_insurances[i].osgop_files || [];
              if (!formFiles?.length) {
                response.errors[`osgop_insurances.${i}.osgop_files`] = [
                  `Поле ${formatMessage({ id: 'media.osgop_files' })} обязательно.`,
                ];
              }
            }
          }
        }
        setFormError(response, setError);
        errorNotification('Сохранение формы обращения', getResponseError({ error: response && response.message ? response.message : '' }));
      });
  };

  const deleteUploadFile = index => {
    const newFiles = [...additionalFiles];
    newFiles.splice(index, 1);
    setAdditionalFiles(newFiles);
  };

  const handleChangeFile = newFiles => {
    const values = [...additionalFiles, ...newFiles];
    setAdditionalFiles(values);
  };

  React.useEffect(() => {
    const subscription = watch(values => {
      if (values && values.applicant && typeof values.applicant.legal_entity_type !== 'undefined') {
        setLegalEntityType(values.applicant.legal_entity_type);
      }
      if (values && values.applicant && typeof values.applicant.federal_law_number !== 'undefined') {
        setFederalLaw(values.applicant.federal_law_number);
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  React.useEffect(() => {
    setValue('application_carrier.has_employees', !legalEntityType);

    // if (procedure === PROCEDURE_TYPE.PROCEDURE_1227_1 && legalEntityType === USER_TYPE.PRIVATE_PERSON) {
    //   setValue('application_carrier.order_services_attach', [{}]);
    // } else {
    //   setValue('application_carrier.order_services_attach', []);
    // }
    setValue('applicant.isMatch', legalEntityType === USER_TYPE.LEGAL);
  }, [legalEntityType]);

  if (!procedure) return null;

  // Vehicle Карточка легкового такси
  // Carrier Карточка перевозчика

  const isVehicle = PROCEDURE_VEHICLE_TYPES.includes(procedure);
  const isSzlt = PROCEDURE_SZLT_TYPES.includes(procedure);
  const isCarrier = PROCEDURE_CARRIER_TYPES.includes(procedure);
  const numberHelperAction = isVehicle ? vehiclesHelper : isSzlt ? szltHelper : carrierHelper;
  // ? USER_TYPE_LIST.filter(f => f.value !== USER_TYPE.PRIVATE_PERSON && f.value !== USER_TYPE.PRIVATE_PERSON_OLD)
  const availableTypes = (procedure === PROCEDURE_TYPE.PROCEDURE_1228_1
    || procedure === PROCEDURE_TYPE.PROCEDURE_1228_2
    || procedure === PROCEDURE_TYPE.PROCEDURE_1228_3
    || procedure === PROCEDURE_TYPE.PROCEDURE_1228_4)
    ? USER_TYPE_LIST
    : procedure !== PROCEDURE_TYPE.PROCEDURE_kt_exlt ? USER_TYPE_LIST.filter(f => f.value !== USER_TYPE.PRIVATE_PERSON_OLD) : USER_TYPE_LIST;

  return ReactDOM.createPortal(
    <div className="application-form">
      <TimerLoader
        loading={loader || loadingCreateApplication || loadingEditApplicationById || loadingRegisterMaisEgu}
      />
      <FormHeader
        onClose={handleDraft()}
        procedure={procedure}
        title={title}
        titleFull={titleFull}
        currentApplication={currentApplication}
        isEdit={isEdit}
      />
      <div className="application-form-body">
        <form className="application-form-content">
          <div className="application-form-fields-header">Заполните информацию о документе</div>
          <div className="application-form-fields">
            <div className="application-form-fields-wrapper custom-scroll-theme">
              <div className="afc-body">
                <div className="afc-main">
                  <AccordionWithPreview
                    title="Информация об обращении"
                    component={ApplicationInfo}
                    componentProps={{
                      control,
                      formMeta,
                      numberHelperAction,
                      procedure,
                      isEdit,
                      getValues,
                      setValue,
                    }}
                  />
                  <AccordionWithPreview
                    title="Заявитель"
                    component={ApplicantForm}
                    componentProps={{
                      procedure,
                      watch,
                      getValues,
                      setValue,
                      control,
                      federal_law_number: federalLaw,
                      formMeta,
                      applicantType: legalEntityType,
                      availableTypes,
                      prefix: 'applicant.',
                      loadApplication,
                    }}
                  />
                  <RepresentativeForm
                    watch={watch}
                    setValue={setValue}
                    getValues={getValues}
                    setToggleRepresentative={setToggleRepresentative}
                    control={control}
                    formMeta={formMeta}
                    currentApplication={currentApplication}
                    prefix="representative."
                  />
                </div>
                <div className="afc-registry">
                  {isCarrier ? (
                    <ApplicationCarrierForm
                      selectedProcedure={procedure}
                      watch={watch}
                      control={control}
                      formMeta={formMeta}
                      legalEntityType={legalEntityType}
                      setValue={setValue}
                      prefix="application_carrier."
                      numberHelperAction={numberHelperAction}
                      getValues={getValues}
                      procedure={procedure}
                      errors={errors}
                      labelPrefix="carrier."
                    />
                  ) : null}
                  {isSzlt ? (
                    <ApplicationSzltForm
                      selectedProcedure={procedure}
                      watch={watch}
                      control={control}
                      formMeta={formMeta}
                      applicantType={legalEntityType}
                      prefix="application_order_service."
                      numberHelperAction={numberHelperAction}
                      setValue={setValue}
                      getValues={getValues}
                      procedure={procedure}
                      labelPrefix="szlt."
                    />
                  ) : null}
                  {isVehicle ? (
                    <ApplicationVehicleForm
                      selectedProcedure={procedure}
                      watch={watch}
                      control={control}
                      getFieldState={getFieldState}
                      formMeta={formMeta}
                      federal_law_number={federalLaw}
                      applicantType={legalEntityType}
                      prefix="application_vehicle."
                      numberHelperAction={numberHelperAction}
                      procedure={procedure}
                      getValues={getValues}
                      setValue={setValue}
                      labelPrefix="vehicle."
                    />
                  ) : null}
                  <ReorganizationJuridicalForm
                    procedure={procedure}
                    setValue={setValue}
                    getValues={getValues}
                    control={control}
                    formMeta={formMeta}
                    applicantType={legalEntityType}
                    currentApplication={currentApplication}
                    isEdit={isEdit}
                  />
                  <ServiceMarkForm
                    procedure={procedure}
                    setValue={setValue}
                    getValues={getValues}
                    control={control}
                    formMeta={formMeta}
                    applicantType={legalEntityType}
                    currentApplication={currentApplication}
                    isEdit={isEdit}
                  />
                  <FIOForm
                    procedure={procedure}
                    setValue={setValue}
                    getValues={getValues}
                    control={control}
                    formMeta={formMeta}
                    applicantType={legalEntityType}
                    currentApplication={currentApplication}
                    isEdit={isEdit}
                  />
                  <AddressForm
                    procedure={procedure}
                    setValue={setValue}
                    getValues={getValues}
                    control={control}
                    formMeta={formMeta}
                    applicantType={legalEntityType}
                    currentApplication={currentApplication}
                    isEdit={isEdit}
                  />
                  <OgrnForm
                    procedure={procedure}
                    getValues={getValues}
                    setValue={setValue}
                    control={control}
                    formMeta={formMeta}
                    applicantType={legalEntityType}
                    currentApplication={currentApplication}
                    isEdit={isEdit}
                  />
                  <OgrnipForm
                    procedure={procedure}
                    setValue={setValue}
                    getValues={getValues}
                    control={control}
                    formMeta={formMeta}
                    applicantType={legalEntityType}
                    currentApplication={currentApplication}
                    isEdit={isEdit}
                  />
                  <DriverLicenseForm
                    procedure={procedure}
                    setValue={setValue}
                    control={control}
                    getValues={getValues}
                    formMeta={formMeta}
                    applicantType={legalEntityType}
                    currentApplication={currentApplication}
                    isEdit={isEdit}
                  />
                  <VehicleRegistryBasisForm
                    procedure={procedure}
                    setValue={setValue}
                    getValues={getValues}
                    watch={watch}
                    control={control}
                    formMeta={formMeta}
                    applicantType={legalEntityType}
                    currentApplication={currentApplication}
                    isEdit={isEdit}
                  />
                  <VehicleCertificateForm
                    procedure={procedure}
                    setValue={setValue}
                    getValues={getValues}
                    control={control}
                    formMeta={formMeta}
                    applicantType={legalEntityType}
                    currentApplication={currentApplication}
                    isEdit={isEdit}
                  />
                  <ContractForm
                    procedure={procedure}
                    setValue={setValue}
                    control={control}
                    getValues={getValues}
                    formMeta={formMeta}
                    applicantType={legalEntityType}
                    currentApplication={currentApplication}
                    isEdit={isEdit}
                  />
                  <SPBForm
                    procedure={procedure}
                    setValue={setValue}
                    getValues={getValues}
                    watch={watch}
                    control={control}
                    formMeta={formMeta}
                    applicantType={legalEntityType}
                    availableTypes={availableTypes}
                    isEdit={isEdit}
                    currentApplication={currentApplication}
                  />
                  <NewSZLTForm
                    procedure={procedure}
                    setValue={setValue}
                    getValues={getValues}
                    watch={watch}
                    control={control}
                    formMeta={formMeta}
                    applicantType={legalEntityType}
                    availableTypes={availableTypes}
                    isEdit={isEdit}
                    currentApplication={currentApplication}
                  />
                  {isCarrier ? (
                    <ApplicationCarrierSzltForm
                      selectedProcedure={procedure}
                      watch={watch}
                      control={control}
                      formMeta={formMeta}
                      legalEntityType={legalEntityType}
                      setValue={setValue}
                      prefix="application_carrier."
                      numberHelperAction={numberHelperAction}
                      getValues={getValues}
                      procedure={procedure}
                      errors={errors}
                      labelPrefix="carrier."
                    />
                  ) : null}
                  <div className="mb-3" />
                  <div className="f4">Прикреплённые файлы</div>
                  <div className="application-additional-file">
                    <UploadFileList
                      list={additionalFiles || []}
                      deleteFile={deleteUploadFile}
                      className="file-list-left"
                    />
                    <UploadZone
                      type="text"
                      inputProps={{
                        onChange: handleChangeFile,
                      }}
                      variant="material"
                      withLabel
                      disabled
                      zoneText="Загрузите файл или перетащите файл в эту область"
                    />
                  </div>
                  <FileView
                    files={currentApplication?.files || []}
                    deletedFileList={deletedFileList}
                    setDeletedFileList={setDeletedFileList}
                    isDeleted
                  />
                  {![PROCEDURE_TYPE.PROCEDURE_1227_1, PROCEDURE_TYPE.PROCEDURE_1227_7, PROCEDURE_TYPE.PROCEDURE_1227_9].includes(procedure)
                    ? <div className="hr-row" /> : null}
                  <Row className="row-cols-1">
                    <FieldDTOWithCol
                      control={control}
                      type="text"
                      component={TextAreaWithLabel}
                      dtoObject={{
                        name: 'comment',
                        type: String,
                        validators: [],
                        labelKey: 'application.comment',
                      }}
                      variant="material"
                    />
                  </Row>
                </div>
              </div>
            </div>
          </div>
          <div className="application-form-footer">
            <Button onClick={() => handleValidateAndSave()}>{isEdit ? 'Сохранить' : 'Создать'}</Button>
            <Button variant="secondary" onClick={onCancel}>Отменить</Button>
          </div>
        </form>
      </div>
    </div>,
    document.getElementById('app-content'),
  );
}
